var map = {
	"./Borang_KWSP_17A_(Khas_2021).xlsx": 1136,
	"./bulk-employees-payslips-template.xlsx": 1137
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1135;



// WEBPACK FOOTER //
// ./files nonrecursive /^/.//